import classnames from 'classnames';
import React, { ReactElement } from 'react';

import * as styles from './TableCell.module.scss';

interface TableCellProps {
  content: ReactElement;

  isSorted?: boolean;
}

const TableCell: React.FC<TableCellProps> = (props) => {
  const { content, isSorted } = props;
  const classes = classnames([
    {
      [styles['TableCell__Sorted']]: isSorted,
    },
  ]);
  return <td className={classes}>{content}</td>;
};

export default TableCell;
